module.exports = __webpack_public_path__ + "static/media/logo-right-grey.eb88a107.png";